import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A recruiter re-entering a screen within the minute gets cache, no spinner.
      staleTime: 60_000,
      gcTime: 15 * 60_000,
      // This is an all-day tool. The prototype had no refetch-on-focus, and
      // restriping every table on alt-tab would be a visible behaviour change.
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // apiClient owns retries: network errors and 5xx are re-sent there with
      // alerts (sendWithRetry), 401 goes through refresh-and-retry, and 4xx will
      // never succeed. Retrying here as well would multiply the attempts.
      retry: false,
    },
    mutations: { retry: 0 },
  },
})
